import { render, staticRenderFns } from "./Registere.vue?vue&type=template&id=56d187e6&scoped=true&"
import script from "./Registere.vue?vue&type=script&lang=js&"
export * from "./Registere.vue?vue&type=script&lang=js&"
import style0 from "./Registere.vue?vue&type=style&index=0&id=56d187e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d187e6",
  null
  
)

export default component.exports